import { Paper } from "@mui/material"
import moment from "moment"

const AirFTPreview = ({ data, printRef, type, }) => {
    if (data) return (
        <Paper className="page" id="page">
            <table width="100%" className="mt-1 pb-1" style={{ fontSize: 9 }} ref={printRef} >
                <tbody>
                    <tr><td colSpan="2" style={{ textAlign: 'center' }}>*** Petrolimex Aviation., JSC ***</td></tr>
                    <tr><td style={{ textAlign: 'center' }} colSpan="2"><h2>FUEL TICKET</h2></td></tr>
                    {
                        type === 'invoice' ?
                        <>
                            <tr><td style={{ textAlign: 'center' }} colSpan="2">FuelTicket No: {data.fkey}</td></tr>
                            <tr><td style={{ textAlign: 'center' }} colSpan="2">Tax No: {data.code}</td></tr>
                        </>
                        :
                        <tr><td style={{ textAlign: 'center' }} colSpan="2">FuelTicket No: {data.code}</td></tr>
                    }
                    <tr><td style={{ textAlign: 'center' }} colSpan="2">{data.valid_date && moment(data.valid_date).format('[Day] DD [Month] MM [Year] YYYY')}</td></tr>
                    <tr><td colSpan="2" style={{ borderBottom: 1 }}></td></tr>
                    <tr><td colSpan="2">Receiver: {data.customer_name} </td></tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Fuel Type: {data.product_name} </td>
                        <td style={{ textAlign: 'left' }}>ITP Mode: {data.hydrant_sys === 2 ? 'Truck' : 'Hydrant sys'} </td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Location: {data.inventory_name}</td>
                        <td style={{ textAlign: 'left' }}>Vehicle: {data.refueler_no}</td>
                    </tr>
                    <tr><td colSpan="2" style={{ borderBottom: '1px dashed' }}></td></tr>
                    <tr><td style={{ textAlign: 'center' }} colSpan="2"><h2>DETAIL</h2></td></tr>
                    <tr><td colSpan="2" style={{ borderBottom: '1px dashed' }}></td></tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Flight no: {data.flight_no} </td>
                        <td style={{ textAlign: 'left' }}>A/C reg: {data.code_aircraft}</td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Route: {data.route} </td>
                        <td style={{ textAlign: 'left' }}>Cert no: {data.cert_no}</td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Start: {data.start_pump && moment(data.start_pump).format('DD/MM/YYYY HH:mm')}</td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>End: {data.end_pump && moment(data.end_pump).format('DD/MM/YYYY HH:mm')}</td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Density: {parseFloat(data.density).toFixed(4)} </td>
                        <td style={{ textAlign: 'left' }}>Temp: {parseFloat(data.temp).toFixed(2)} </td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Meter Str: {Math.round(data.meter_before_pump)?.toLocaleString()} </td>
                        <td style={{ textAlign: 'left' }}>Meter End: {Math.round(data.meter_after_pump)?.toLocaleString()} </td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>USG: {Math.round(data.gallon || data.sub_gallon)?.toLocaleString()}  </td>
                        <td style={{ textAlign: 'left' }}>Liter: {Math.round(data.sub_lit || data.lit)?.toLocaleString()} </td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>L15: {Math.round(data.sub_l15 || data.l15)?.toLocaleString()} </td>
                        <td style={{ textAlign: 'left' }}>Convert weight: {Math.round(data.sub_kg || data.kg)?.toLocaleString()} kg</td>
                    </tr>
                    <tr><td colSpan="2" style={{ borderBottom: 1 }}></td></tr>
                    <tr><td colSpan="2" style={{ borderBottom: '1px dashed' }}></td></tr>
                    <tr>
                        <td style={{ textAlign: 'left' }} colSpan="2">For deliverer: {data.staff_name}
                            <div style={{height: 100}}><img style={{ width: '100%', objectFit: 'contain', maxHeight: 100 }} src={data.deliverer_sign} alt='' /></div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }} colSpan="2">For receiver: {data.name_receiver}
                            <div style={{height: 100}}><img style={{ width: '100%', objectFit: 'contain', maxHeight: 100 }} src={data.customer_sign} alt='' /></div>
                        </td>
                    </tr>
                    <tr><td colSpan="2" style={{ borderBottom: 1 }}></td></tr>
                    <tr>
                        <td colSpan="2" style={{ textAlign: 'center' }}>
                            <span>I confirm that this fuel is in accordance with the quantity and technical standard</span>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="2" style={{ textAlign: 'center' }}>
                            <span>Printed time: </span>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="2" style={{ textAlign: 'center' }}>Tax invoice will be issued within same day</td>
                    </tr>
                </tbody>
            </table>
        </Paper>
    )
    else return 'No data found'
}
export const TruckFTReview = ({ data, printRef, type, }) => {
    if (data) return (
        <Paper className="page" id="page">
            <table width="100%" className="mt-1 pb-1" style={{ fontSize: 9 }} ref={printRef} >
                <tbody>
                    <tr><td colSpan="2" style={{ textAlign: 'center' }}>*** Petrolimex Aviation., JSC ***</td></tr>
                    <tr><td style={{ textAlign: 'center' }} colSpan="2"><h2>PHIẾU XUẤT HÀNG GỬI</h2></td></tr>
                    {
                        type === 'invoice' ?
                        <>
                            <tr><td style={{ textAlign: 'center' }} colSpan="2">FuelTicket No: {data.fkey}</td></tr>
                            <tr><td style={{ textAlign: 'center' }} colSpan="2">Tax No: {data.code}</td></tr>
                        </>
                        :
                        <tr><td style={{ textAlign: 'center' }} colSpan="2">FuelTicket No: {data.code}</td></tr>
                    }
                    <tr><td style={{ textAlign: 'center' }} colSpan="2">({data.valid_date && moment(data.valid_date).format('[Ngày] DD [tháng] MM [năm] YYYY')})</td></tr>
                    <tr><td colSpan="2" style={{ borderBottom: 1 }}></td></tr>
                    <tr><td colSpan="2">Bên nhận: {data.customer_name} </td></tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Loại hàng: {data.product_name} </td>
                        <td style={{ textAlign: 'left' }}>Loại hình: {data.hydrant_sys === 2 ? 'Truck' : 'Hydrant sys'} </td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Kho xuất: {data.inventory_name}</td>
                        <td style={{ textAlign: 'left' }}>Phương tiện xuất: {data.refueler_no}</td>
                    </tr>
                    <tr><td colSpan="2" style={{ borderBottom: '1px dashed' }}></td></tr>
                    <tr><td style={{ textAlign: 'center' }} colSpan="2"><h2>THÔNG TIN CHI TIẾT</h2></td></tr>
                    <tr><td colSpan="2" style={{ borderBottom: '1px dashed' }}></td></tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Số/ ký hiệu phương tiện nhận: {data.refueler_license_plate} </td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Thời gian bắt đầu: {data.start_pump && moment(data.start_pump).format('DD/MM/YYYY HH:mm')}</td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Thời gian kết thúc: {data.end_pump && moment(data.end_pump).format('DD/MM/YYYY HH:mm')}</td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Tỷ trọng: {parseFloat(data.density).toFixed(4)} </td>
                        <td style={{ textAlign: 'left' }}>Nhiệt độ: {parseFloat(data.temp).toFixed(2)} </td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Số công tơ đầu: {Math.round(data.meter_before_pump)?.toLocaleString()} </td>
                        <td style={{ textAlign: 'left' }}>Số công tơ cuối: {Math.round(data.meter_after_pump)?.toLocaleString()} </td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Lượng hàng (USG): {Math.round(data.gallon || data.sub_gallon)?.toLocaleString()}  </td>
                        <td style={{ textAlign: 'left' }}>Liter: {Math.round(data.sub_lit || data.lit)?.toLocaleString()} </td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }}>Quy đổi khối lượng: {Math.round(data.sub_kg || data.kg)?.toLocaleString()} kg</td>
                    </tr>
                    <tr><td colSpan="2" style={{ borderBottom: 1 }}></td></tr>
                    <tr><td colSpan="2" style={{ borderBottom: '1px dashed' }}></td></tr>
                    <tr>
                        <td style={{ textAlign: 'left' }} colSpan="2">Đại diện bên giao: {data.staff_name}
                            <div style={{height: 100}}><img style={{ width: '100%', objectFit: 'contain', maxHeight: 100 }} src={data.deliverer_sign} alt='' /></div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: 'left' }} colSpan="2">Đại diện bên nhận: {data.name_receiver}
                            <div style={{height: 100}}><img style={{ width: '100%', objectFit: 'contain', maxHeight: 100 }} src={data.customer_sign} alt='' /></div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </Paper>
    )
    else return 'No data found'
}
export default AirFTPreview